export const environment = {
  production: false,
  BASE_URL: 'https://live-api.luciditv.net/',
  APP_URL: 'https://mapi-v2.luciditv.net/'
};
